export const INVITATION_MODAL_TABS = {
  FRIENDS: 'Friends',
  LINK: 'Invite Link',
} as const

export type InvitationModalTab = (typeof INVITATION_MODAL_TABS)[keyof typeof INVITATION_MODAL_TABS]
